var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'Translator ' + this.className},[_c('ul',{staticClass:"Translator__list"},_vm._l((_vm.languages),function(l){return _c('li',{key:l.lang,class:'Translator__item' + (_vm.state.language.lang === l.lang ? ' Translator__item--active' : ''),on:{"click":function($event){return _vm.updateLang(l)}}},[_vm._v(_vm._s(l.lang))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }